import Vue from 'vue';
import App from './App';
import Cookies from 'js-cookie';
import Meta from 'vue-meta';

import i18n   from './lang';
import router from './router';
import store  from './store';
import methods from './methods';

import { constant } from './methods/constant.js';

import './assets/scss/index.scss';
// import 'vx-easyui/dist/themes/default/easyui.css';
// import 'vx-easyui/dist/themes/icon.css';
// import 'vx-easyui/dist/themes/vue.css';
import './global.scss';
import EasyUI from 'vx-easyui';

Vue.use(EasyUI);
const addedModules = new Set();

class EasyVue {
    constructor(config) {
        
        this.context = {};  //将国际化、路由、存储放在context中，方便以context为参数，传给各模块，通过建造者模式来构造数据。
        this.context.config = config;
        this.context.Vue    = Vue;
        this.context.i18n   = i18n;
        this.context.router = router;
        this.context.store  = store;
        this.context.Vue.use(Meta);

        methods(this.context);  

        // 循环处理模块
        for (const module of addedModules) {
            module(this.context);  //高用各模块中的module_index.js的构造方法，通过建行者模式来构造数据。
        }

        this.context.Vue.prototype.$const = constant;

        return new Vue({
            el: '#app',
            router: this.context.router,
            store: this.context.store,
            i18n: this.context.i18n,
            render: (h) => h(App)
        });
    }
    //加入模块中module_index.js的默认方法，后面会对addedModules进行迭代，构造vue树的数据。
    static add(module) {
        addedModules.add(module);
    }

    static use(plugin, options) {
        if (options) {
          Vue.use(plugin, options);
        } else {
          Vue.use(plugin, {
            size: Cookies.get('size') || 'medium',
            i18n: (key, value) => i18n.t(key, value)
          });
        }
      }

}

export default EasyVue;